import { Box, Chip } from '@mui/material'
import { ReactNode } from 'react'

interface IProps {
  text: string
  color: string
  mobile?: boolean
  icon?: ReactNode | null
}

export const ColoredChip = ({ text, color, mobile, icon }: IProps) => {
  return (
    <Chip
      variant="outlined"
      sx={{
        fontSize: '16px',
        color: color,
        borderColor: color,
        borderRadius: '8px',
        borderWidth: '2px',
        marginLeft: mobile ? 'auto' : 0,
        p: mobile ? '2px 4px' : '3px 12px',
      }}
      label={
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
          {text}
          {icon && icon}
        </Box>
      }
    />
  )
}
